/* eslint-disable */
export const SurveyData = {
  title: "Diseño personalizado",
  description: "Cotización",
  sections: [
    {
      id: "personal-info",
      title: "Información Personal",
      iconType: "material-icon",
      icon: "description",
      description: "",
      questions: [
        {
          id: "para_quien",
          title: "¿Quieres algo para ti? ó ¿Para alguien especial?",
          type: "select",
          required: false,
          options: [
            { value: "Para mi", label: "Para mi" },
            { value: "Alguien más", label: "Alguien más" },
            { value: "Para mi y alguien más", label: "Para mi y alguien más" }
          ]
        },
        {
          id: "tiene_diseno",
          title: "¿Tienes un diseño en mente? o ¿Te gustaría que te propusieramos ideas?",
          type: "select",
          required: false,
          options: [
            { value: "Ya sé que diseño va a tener", label: "Ya sé que diseño va a tener" },
            { value: "No estoy seguro (a) de cómo será, pero tengo ideas", label: "No estoy seguro (a) de cómo será, pero tengo ideas" },
            { value: "Me gustaría recibir ideas", label: "Me gustaría recibir ideas" }
          ]
        },
        {
          id: "fecha",
          title: "Háznos saber si tienes una fecha planeada para asegurarnos de tenerlo a tiempo",
          type: "select",
          required: false,
          options: [
            { value: "Solo necesito cotización", label: "Solo necesito cotización" },
            { value: "Será pronto (menos de 3 meses)", label: "Será pronto (menos de 3 meses)" },
            { value: "No tengo prisa (mas de 3 meses)", label: "No tengo prisa (mas de 3 meses)" },
            { value: "Sí, tengo fecha", label: "Sí, tengo fecha" }
          ],
          optional_questions:[
            {
              id: "fecha_select",
              opcion_select: ["Sí, tengo fecha"],
              title: "Selecciona la fecha de entrega",
              type: "date"
            }
          ]
        },
        {
          id: "rango_precio",
          title: "¿Cuál es tu rango de precio?",
          type: "scale",
          required: false,
          min: 30000,
          max: 200000,
          description: ""
        }
      ]
    },
    {
      id: "service-experience",
      title: "Construcción",
      iconType: "image",
      icon: "assets/img/menu/compromiso.svg",
      description: "",
      questions: [
        {
          id: "material",
          title: "¿De qué material lo deseas?",
          type: "select",
          required: false,
           options: [
            { value: "14 kilates", label: "14 kilates" },
            { value: "18 kilates", label: "18 kilates" }
          ]
        },
        {
          id: "color",
          title: "¿De qué color lo deseas?",
          type: "select",
          required: false,
          options: [
            { value: "Oro Amarillo", label: "Oro Amarillo" },
            { value: "Oro Blanco", label: "Oro Blanco" },
            { value: "Oro Rosa", label: "Oro Rosa" }
          ]
        }
      ]
    },
    {
      id: "feedback",
      title: "Ideas y Comentarios",
      iconType: "material-icon",
      icon: "assignment_turned_in",
      description: "",
      questions: [
        {
          id: "idea",
          title: "Descríbenos tu idea, no omitas ningún detalle",
          type: "textarea",
          required: false,
          placeholder: "Escribe aquí"
        },
        {
          id: "grabado",
          title: "¿Deseas agregar algún grabado?",
          type: "select",
          required: false,
          options: [
            { value: "Si", label: "Si" },
            { value: "No", label: "No" }
          ],
          optional_questions:[
            {
              id: "texto_grabado",
              opcion_select: ["Si"],
              title: "Escribe lo que se grabará",
              type: "text"
            }
          ]
        },
        {
          id: "informacion_adicional",
          title: "Información adicional",
          type: "textarea",
          required: false,
          placeholder: "Escribe aquí"
        },
        {
          id: "images",
          title: "Adjuntar imagenes",
          type: "images",
          required: false
        }
      ]
    },
    {
      id: "personal-data",
      title: "Información personal",
      iconType: "material-icon",
      icon: "person",
      description: "",
      questions: [
        {
          id: "nombre",
          title: "Nombre Completo",
          type: "text",
          required: true,
          placeholder: "Nombre"
        },
        {
          id: "celular",
          title: "Celular o Whatsapp",
          type: "text",
          required: true,
          pattern:"^[0-9]{10}$",
          notValidMessage: "El celular debe tener exactamente 10 dígitos numéricos",
          placeholder: "Escribe aquí"
        },
        {
          id: "email",
          title: "Correo Electrónico",
          type: "email",
          pattern: "^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$",
          notValidMessage: "Por favor ingresa un correo válido (usuario@dominio.com)",
          required: true,
          placeholder: "Correo"
        }
      ]
    }
  ]
}

export function FlatSurvey() {
  return SurveyData.sections.flatMap(section =>
    section.questions.flatMap(question => {
      const resp = [{
        id: question.id,
        type: question.type,
        question: question.title,
        response: null
      }];

      if (question.optional_questions) {
        resp.push(...question.optional_questions.map(opt => ({
          id: opt.id,
          type: opt.type,
          question: opt.title,
          response: null
        })));
      }

      return resp;
    })
  );
}